import { Alert, List, Stack, Text } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'
import { type FC } from 'react'

export const PhotoGuidelinesPanel: FC = () => (
  <Alert color='blue' icon={<IconInfoCircle size={18} />} radius='lg' title='Photo guidelines'>
    <Stack spacing='xs'>
      <Text size='sm' fw={600}>Acceptable photos</Text>
      <List size='sm' spacing={2}>
        <List.Item>Classroom environments, learning spaces, playgrounds, and facilities</List.Item>
        <List.Item>Children engaged in activities where faces are not identifiable (photographed from behind, at a distance, or with faces blurred)</List.Item>
        <List.Item>Photos of staff only with their consent</List.Item>
        <List.Item>Program materials, signage, or learning setups</List.Item>
      </List>
      <Text size='sm' fw={600} mt='sm'>Not acceptable</Text>
      <List size='sm' spacing={2}>
        <List.Item>Clearly identifiable images of children (faces visible, name labels visible)</List.Item>
        <List.Item>Photos that include personal or sensitive information</List.Item>
        <List.Item>Images that could be perceived as unsafe, inappropriate, or promotional beyond program representation</List.Item>
      </List>
    </Stack>
  </Alert>
)
